export default "__VITE_ASSET__CZYbjynH__"